<template>
  <div :class="contentClasses">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: {
    light: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentClasses () {
      return {
        'content': true,
        'light': this.light,
        'large': this.large
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  font-size: $fs-bread;

  p {
    margin: 1em auto;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    font-size: $fs-h3;
    line-height: $lh-heading;
    margin-bottom: 0;

    & + * {
      margin-top: 0;
    }
  }
}

.content + .content {
  margin-top: 2em;
}

.light {
  color: $c-text;
}

.large {
  font-size: $fs-intro;
  line-height: $lh-intro;
}
</style>
